// extracted by mini-css-extract-plugin
export var bodyText = "Hero-module--bodyText--2xpai";
export var container = "Hero-module--container--Zgj0a";
export var desktopBackground = "Hero-module--desktopBackground--1ZxhH";
export var desktopMobile = "Hero-module--desktopMobile--4hm5u";
export var imageOverlay = "Hero-module--image-overlay--geYSg";